import {
	Box,
	Center,
	Heading,
	Text,
	Tabs,
	TabList,
	TabPanels,
	Tab,
	TabPanel,
} from "@chakra-ui/react";
import { useWeb3React } from "@web3-react/core";
import Head from "next/head";
import React, { useEffect, useState } from "react";
import Shell from "../components/ui/layouts/Shell";
import { ownedRaiders } from "../util/web3/interactBank";
import { questingRaiders } from "../util/web3/interactQuests";
import { Raider } from "../types/raider";
import RaiderCardLayout from "../components/ui/layouts/RaiderCardLayout";

export default function Home() {
	const [inactiveRaiders, setInactiveRaiders] = useState<Raider[]>([]);
	const [activeQuestRaiders, setActiveQuestRaiders] = useState<Raider[]>([]);
	const [allRaiders, setAllRaiders] = useState<Raider[]>([]);
	const { account } = useWeb3React();

	const [tabChange, setTabChange] = useState<boolean>();

	const [isLoading, setIsLoading] = useState(false);

	useEffect(() => {
		const fetchData = async () => {
			setIsLoading(true);
			try {
				const tempInactiveRaiders = await ownedRaiders();
				if (tempInactiveRaiders) {
					setInactiveRaiders(tempInactiveRaiders);
					setAllRaiders(allRaiders.concat(inactiveRaiders))
				}
				const tempActiveQuestRaiders = await questingRaiders();
				if (tempActiveQuestRaiders) {
					setActiveQuestRaiders(tempActiveQuestRaiders);
				}
				setAllRaiders(allRaiders.concat(activeQuestRaiders))
				setIsLoading(false);
			} catch (e) {
				setIsLoading(false);
			}
		};

		fetchData();
	}, [account, tabChange]);

	return (
		<Shell>
			<Head>
				<title>Crypto Raiders - Quests</title>
			</Head>
			<Box as="section" pb="20">
				<Box bg="gray.700" pt="20" pb="20">
					<Box
						maxW={{ base: "xl", md: "7xl" }}
						mx="auto"
						px={{ base: "6", md: "8" }}
					>
						<Box mb="6" color="white" maxW="xl">
							<Heading
								size="2xl"
								letterSpacing="tight"
								fontWeight="extrabold"
								lineHeight="normal"
								fontFamily="Press Start 2P"
							>
								⚔️ Your Raiders
							</Heading>
							<Text fontSize="lg" mt="0" fontWeight="medium" color="gray.200">
								You have{" "}
								{inactiveRaiders === undefined ? "-" : inactiveRaiders?.length}{" "}
								raiders available for questing, and{" "}
								{activeQuestRaiders === undefined
									? "-"
									: activeQuestRaiders?.length}{" "}
								currently on a quest.
							</Text>
							<Text fontSize="sm" mt="4" color="gray.400">
								These are your Raiders waiting to take on their next quest! You
								can also buff them with Questing tools, and Mounts to speed them
								up. Send them off on their next adventure, but remember,
								you&apos;ll have to wait for them to come back...
							</Text>
						</Box>
					</Box>
				</Box>
				<Box mt="-20">
					<Box
						maxW={{ base: "xl", md: "7xl" }}
						mx="auto"
						px={{ base: "6", md: "8" }}
					>
						<Center hidden={!isLoading}>
							<div className="sk-folding-cube">
								<div className="sk-cube1 sk-cube"></div>
								<div className="sk-cube2 sk-cube"></div>
								<div className="sk-cube4 sk-cube"></div>
								<div className="sk-cube3 sk-cube"></div>
							</div>
						</Center>
						<Tabs
							isFitted
							variant="enclosed"
							mt={10}
							onChange={() => setTabChange(!tabChange)}
						>
							<TabList mb="1em">
								<Tab>Available</Tab>
								<Tab>Questing</Tab>
							</TabList>
							<TabPanels>
								<TabPanel>
									<RaiderCardLayout 
										isLoading={isLoading}
										raiders={inactiveRaiders}
										button="quests"
									/>
								</TabPanel>
								<TabPanel>
									<RaiderCardLayout 
										isLoading={isLoading}
										raiders={activeQuestRaiders}
										button="quest-status"
									/>
								</TabPanel>
							</TabPanels>
						</Tabs>
					</Box>
				</Box>
			</Box>
		</Shell>
	);
}
